export const APP_THEME_LIGHT = 'light';
export const APP_THEME_DARK = 'dark';
export const FINDER_REQUESTS_INTERVAL = 300;
export const FINDER_MIN_NAME_LENGTH = 2;
export const FINDER_PLACEHOLDER = 'Type a name here';
export const FINDER_ERROR_NOT_FOUND = 'Not Found. Try to type another name.';
export const FINDER_ERROR_NAME_LENGTH_TOO_FEW = `Name length should be more than ${FINDER_MIN_NAME_LENGTH} letters.`;
export const NAME_MORTY = 'Morty';
export const NAME_RICK = 'Rick';

export default {
  FINDER_REQUESTS_INTERVAL,
  FINDER_MIN_NAME_LENGTH,
  FINDER_PLACEHOLDER,
  FINDER_ERROR_NOT_FOUND,
  FINDER_ERROR_NAME_LENGTH_TOO_FEW,
  NAME_MORTY,
  NAME_RICK,
};
